import React from 'react';
import { connect } from 'react-redux';

const ShoppingLinks = ({ custSeg, shoppingLinks }) => {
    return (
        <section className="myShoppingLinks">
            <div className="large-12">
                <ul>
                    {shoppingLinks &&
                        shoppingLinks.map(({ href, name, key, customerSegements }, i) => {
                            if (!customerSegements || customerSegements.indexOf(custSeg) > -1) {
                                return (
                                    <li className={i === shoppingLinks.length - 1 ? 'last-link' : null} key={i}>
                                        <a href={href}>{key || name}</a>
                                    </li>
                                );
                            } else {
                                return null;
                            }
                        })}
                </ul>
            </div>
        </section>
    );
};

const mapStateToProps = (state, ownProps) => {
    const { profileData = {} } = state.userData;
    const { shoppingLinks } = state.siteConfig;
    const { footerLinks } = state.slugInfo.components;

    return {
        custSeg: profileData.personData.custSeg,
        shoppingLinks: footerLinks && footerLinks.length > 0 ? footerLinks : shoppingLinks,
    };
};

export default connect(mapStateToProps, null)(ShoppingLinks);
